import { cn, formatNumber } from "utils";

import React from "react";
import NextImage from "../../NextImage";
import { EarningsCalendarItemProps } from "./types";
import { I18nUtil } from "@utils/i18n";
import Translations from "@translate/components/Home/EarningsCalendar/EarningsCalendarItem";

const I18n = I18nUtil.createScoped(Translations);

/**
 * @description Individual earnings calendar item component
 */
export const EarningsCalendarItem: React.FC<EarningsCalendarItemProps> = ({
  item,
  isLast = false,
  index,
}) => {
  const { company_name, revenue_estimate, revenue_actual, logo } =
    item?.earning_calendar || {
      company_name: "",
      revenue_estimate: 0,
      revenue_actual: 0,
      logo: "",
    };

  return (
    <>
      <div
        className={cn(
          "flex items-center w-full gap-2 py-4 border-b border-border_white_transparent10",
          isLast && "border-b-0",
          index === 0 && "pt-2",
        )}
      >
        <div className="rounded-full border-2 border-border_solid overflow-hidden">
          <NextImage
            src={logo}
            alt={company_name}
            className="w-8 h-8 rounded-full"
          />
        </div>
        <div>
          <div
            className="text-content_primary body_medium_m max-w-[160px] truncate"
            title={company_name || item?.symbols?.[0]?.symbol}
          >
            {company_name || item?.symbols?.[0]?.symbol}
          </div>
          <div className="flex gap-4">
            <div className="flex items-center">
              <div className="text-content_tertiary body_medium_s whitespace-nowrap">
                {I18n.t("Revenue: Est.")}
              </div>
              <div className="text-content_primary body_medium_s whitespace-nowrap">
                {revenue_estimate
                  ? formatNumber(Number(revenue_estimate))
                  : "--"}
              </div>
            </div>
            <div className="flex items-center">
              <div className="text-content_tertiary body_medium_s whitespace-nowrap">
                {I18n.t("Act.")}
              </div>
              <div className="text-content_primary body_medium_s whitespace-nowrap">
                {revenue_actual ? formatNumber(Number(revenue_actual)) : "--"}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
